// client/src/components/profissionais/ProfissionaisRow.js
import React, { useState } from 'react';
import { MoreVertical, CheckCircle, XCircle, Phone } from 'lucide-react';

const ProfissionaisRow = ({ profissional, onOpenActions }) => {
    const user = profissional.user || profissional;
    
    // Status e Contadores limpos extraídos pelo Hook
    const unidadesCount = profissional.unidadesCount || profissional.estatisticas?.totalUnidades || 0;
    const servicosCount = profissional.servicosCount || profissional.estatisticas?.totalServicos || 0;
    
    const status = profissional.profissionalInfo?.status || profissional.status || 'ativo';
    const isAtivo = status === 'ativo';

    const [imgError, setImgError] = useState(false);

    const getPhotoUrl = () => {
        if (imgError) {
             return `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || '')}&background=random`;
        }
        const photo = user.photoUrl || user.photo;
        if (photo && typeof photo === 'string' && photo.length > 5) {
            return photo;
        }
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || '')}&background=random`;
    };

    return (
        <tr className={`table-row-hover ${!isAtivo ? 'opacity-60 bg-gray-50' : ''}`}>
            
            {/* COLUNA: NOME DO PROFISSIONAL */}
            <td className="td-name">
                <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10">
                        <img 
                            className="h-10 w-10 rounded-full object-cover border border-gray-200" 
                            src={getPhotoUrl()} 
                            alt={user.name}
                            onError={(e) => {
                                e.target.onerror = null;
                                setImgError(true);
                            }}
                        />
                    </div>
                    <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">
                            {user.name}
                        </div>
                    </div>
                </div>
            </td>
            
            {/* COLUNA: TELEFONE */}
            <td className="text-sm text-gray-600 font-mono">
                {user.telefone ? (
                    <span className="flex items-center">
                        <Phone size={12} className="mr-1 text-gray-400" />
                        {user.telefone}
                    </span>
                ) : (
                    '-'
                )}
            </td>

            {/* COLUNA: SERVIÇOS */}
            <td className="text-center">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 border border-gray-200">
                    {servicosCount}
                </span>
            </td>

            {/* COLUNA: UNIDADES */}
            <td className="text-center">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 border border-gray-200">
                    {unidadesCount}
                </span>
            </td>
            
            {/* COLUNA: STATUS */}
            <td className="text-center">
                <div className="flex items-center justify-center">
                    {isAtivo ? (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                            <CheckCircle size={12} className="mr-1" /> Ativo
                        </span>
                    ) : (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 border border-red-200">
                            <XCircle size={12} className="mr-1" /> Inativo
                        </span>
                    )}
                </div>
            </td>
            
            {/* COLUNA: AÇÕES PADRONIZADAS */}
            <td className="text-right">
                <div className="flex justify-end">
                    <button
                        onClick={() => onOpenActions(profissional)}
                        className="action-icon-button text-gray-600"
                        title="Ações"
                        type="button"
                    >
                        <MoreVertical size={18} />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default ProfissionaisRow;